<script>
export default {
  data() {
    return {
      listData: [
        {
          title: '1998',
          desc: '从零开始，组建了核心团队',
          imgSrc: '/static/images/about-history-3.png',
        },
        {
          title: '2003',
          desc: '公司是由深圳市远望软件技术有限公司商业事业部改制而来，于2003年改组成立深圳市威名软件技术开发有限公司。',
          imgSrc: '/static/images/about-history-1.png',
        },
        {
          title: ['2013 / ', <span class="month">09</span>],
          desc: '获得深圳优讯信息技术有限公司投资，更名为深圳市优讯龙腾科技有限公司。',
          imgSrc: '/static/images/about-history-2.png',
        },
        {
          title: ['2019 / ', <span class="month">05</span>],
          desc: '由深圳市优讯龙腾科技有限公司全资控股成立了山东悦朋智能科技有限公司。',
          imgSrc: '/static/images/about-history-4.png',
        },
      ],
    }
  },
  render() {
    return (
      <section class="development-history-container">
        <div class="container">
          <div class="sec-title-container">
            <div class="sec-title-zh">发展历程</div>
            <div class="sec-title-en">DEVELOPMENT HISTORY</div>
          </div>
          <div class="development-history-content">
            <ul>
              {this.listData.map((item) => {
                return (
                  <li class={['development-history-item']}>
                    <div class="development-history-item-container">
                      <div class="development-history-item-container-inner">
                        <div class="development-history-item-image-container">
                          <img src={item.imgSrc} alt="" />
                        </div>
                        <div class="development-history-item-content">
                          <div class="development-history-item-title">{item.title}</div>
                          <div class="development-history-item-text">{item.desc}</div>
                        </div>
                      </div>
                    </div>
                    <div class="development-history-item--after absolute-center">
                      <div class="point-container">
                        <div class="out-circle absolute-center"></div>
                        <div class="in-circle absolute-center"></div>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </section>
    )
  },
}
</script>
